// @flow
import { createSelector, Selector } from 'reselect';

export const selectResources: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.ResourceReducer.resources,
  resources => {
    if (resources) {
      return resources;
    }
    return {};
  }
);
